import PropTypes from "prop-types";
import React, { forwardRef, useState, useCallback } from "react";
import classNames from "classnames";
import { Button, ButtonVariant, IconNames } from "@wattpad/web-ui-library";
import EmailSignup from "./EmailSignup";
import { useTrans } from "../../hooks";
import { ConnectImage } from "../../shared-components";
import Checklist from "./RequireSignup/Checklist";
import { SignupHeader } from "./RequireSignup/SignupHeader";
import { AuthenticationOptions } from "./RequireSignup/AuthenticationOptions";
import { FORM_VIEW } from "./constants";

const DetailedSignupForm = forwardRef(
  ({ formType, nextUrl = "/home", title, subtitle, toggleForm }, ref) => {
    const { trans } = useTrans();
    const [isEmailFormView, setIsEmailFormView] = useState(false);

    const handleAuthView = useCallback(
      view => {
        if (view === FORM_VIEW.REGISTER) {
          setIsEmailFormView(true);
        }
        if (view === FORM_VIEW.LOGIN) {
          toggleForm();
        }
      },
      [toggleForm]
    );

    return (
      <div
        ref={ref}
        id="authentication"
        className={classNames("signup-form", "detailed-signup-form-modal", {
          "is-email-form-view": isEmailFormView
        })}
      >
        <div className="signup-prompt-container">
          <div className="signup-prompt-main">
            <div className="signup-prompt-form">
              {!isEmailFormView ? (
                <>
                  <SignupHeader
                    title={title}
                    subtitle={subtitle}
                    hideChecklist
                  />
                  <AuthenticationOptions
                    setAuthFormView={handleAuthView}
                    nextUrl={nextUrl}
                  />
                </>
              ) : (
                <div className="signup-form-container">
                  <Button
                    className="back-button"
                    variant={ButtonVariant.TERTIARY}
                    onClick={() => setIsEmailFormView(false)}
                    leadingIcon={IconNames.WpChevronLeft}
                    label={trans("Back to all signup options")}
                    fullWidth
                  />
                  <div className="panel-body">
                    <EmailSignup formType={formType} nextUrl={nextUrl} />
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="signup-prompt-expanded">
            <ConnectImage
              name="auth/flying-book.svg"
              title=""
              className="signup-prompt-graphic detailed-signup-prompt-graphic"
              width="316"
              height="177"
            />
            <Checklist showHeader />
          </div>
        </div>
      </div>
    );
  }
);

DetailedSignupForm.displayName = "DetailedSignupForm";

DetailedSignupForm.propTypes = {
  formType: PropTypes.string,
  nextUrl: PropTypes.string,
  subtitle: PropTypes.string,
  title: PropTypes.string,
  toggleForm: PropTypes.func.isRequired
};

export default DetailedSignupForm;
